import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Selected_Index } from '../../../../constants/external-constants';
import { RequestHeaders } from "../../../common/header-logo/request-header.component";
import DetailContainer from "../../../common/Layout/details/DetailsLayout.component";
import GLCode from './gl-code.component';
import CostCenter from './cost-code.component';
import { validateAccessModule } from '../../../../utils/helpers.utils';
import { ACCESS_MODULE, MATRIX_INDICATOR } from '../../../../utils/rbac-constants.utils';
import { bindActionCreators } from "@reduxjs/toolkit";
import { filterActions } from '../../../../store/external/filter-reducer/filter-reducer';

class CostAllocation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: Selected_Index.i_Zero,
            contentIndex:  Selected_Index.i_Zero        
        }
    }
    handleSelectedIndex = (index) =>{
        const { resetFilter } = this.props;
        
        this.setState({contentIndex: index});

        if(index !== this.state.contentIndex){
            resetFilter();
        }

    }

    render() {
        let isReadOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.HRManagementDashboardR])
        let isReadAndExtractOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.HRManagementDashboardRE])
        let isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.HRManagementDashboardRW])
        const { contentIndex } = this.state
        return (
            <div className='rate-card-container invoice-wrapper-container inventory-report-component'>
                <RequestHeaders headerTitle={'CostAllocation'} /> 
                <div className="request-table data-table fit-width">
                  <DetailContainer
                     renderTabContent={this.handleSelectedIndex}
                     urlIndex={this.state.activeTab}
                     listTab={ [
                         {
                             "id": Selected_Index.i_Zero,
                             "label": "GL Code",
                             "hidden": false
                         },
                         {
                             "id": Selected_Index.i_One,
                             "label": "Cost Center",
                             "hidden": false,
                             "disable": false
                         },
                        
                     ]}
                  >
                    {contentIndex === Selected_Index.i_Zero && <GLCode />}
                    {contentIndex === Selected_Index.i_One && <CostCenter/>}
                  </DetailContainer>
                </div>
            </div>
        );
    }
}



export default connect(null, dispatch => bindActionCreators(
    Object.assign({}, filterActions),
    dispatch
))(CostAllocation);